/**
 * OccupationalRisk Create Page
 * Page for creating new occupational risk
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Alert,
} from '@mui/material';
import { PageShell } from '../../components';
import { occupationalRiskService } from '../../services/occupationalRiskService';
import { OccupationalRiskFormData } from '../../types/occupationalRisk';
import { OccupationalRiskForm } from './components/OccupationalRiskForm';

export const OccupationalRiskCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: OccupationalRiskFormData) => {
    try {
      setIsSubmitting(true);
      setError(null);
      await occupationalRiskService.createOccupationalRisk(data);
      navigate('/occupational-risks');
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Erro ao criar risco ocupacional');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/occupational-risks');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/home' },
        { label: 'Riscos Ocupacionais', path: '/occupational-risks' },
        { label: 'Novo Risco' },
      ]}
      title="Cadastrar Novo Risco Ocupacional"
      subtitle="Preencha os dados do risco ocupacional (NR-09, NR-15, NR-16)"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent>
          <OccupationalRiskForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isSubmitting={isSubmitting}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default OccupationalRiskCreatePage;
